import * as z from "zod";

export const deleteTicketValidationResults = {
  name: "deleteTicketValidationResults" as const,
  input: z.object({ linearTicketId: z.string() }),
  output: z.object({ deletedCount: z.number() }),
};
